import type { ClassNameValue } from "tailwind-merge"

import { extendTailwindMerge } from "tailwind-merge"

// TODO REPO MIGRATE

const customTwMerge = extendTailwindMerge({
  //@ts-ignore
  classGroups: {
    "font-size": [{ text: ["sm", "bt", "nm", "bg", "sub", "ih6", "ih5", "ih4", "ih3", "ih2", "ih1"] }],
    "text-wrap": [{ text: ["balance"] }],
    "background-color": [{ bg: ["peach-20"] }],
    "animation-delay": [{ delay: ["0", "75", "100", "150", "200", "300", "500", "700", "800", "1000"] }],
    "animation-duration": [{ duration: ["0", "75", "100", "150", "200", "300", "500", "700", "800", "1000"] }],
    // Custom
    "container-max": [{ "container-max": ["480", "600", "1200"] }],
    process: ["horizontal-process", "vertical-process"],
  },
})

export function twMerge(...classLists: ClassNameValue[]): string {
  return customTwMerge(classLists)
}
